module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-minus-fill-03d45899.svg";